(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  class UgcVideos extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.buttons = Array.from(this.querySelectorAll('.ugc-videos__sound-button'));
      this.activeVideo = null;

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onSoundButtonClick.bind(this));
      });

      this.videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.controls = false;
        video.addEventListener('click', this.onVideoClick.bind(this));
        video.addEventListener('pause', () => this.syncButton(video));
        video.addEventListener('play', () => this.syncButton(video));
      });

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
        rootMargin: '120px 0px',
        threshold: 0.1,
      });

      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    onIntersection(entries) {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
          return;
        }

        if (video === this.activeVideo) {
          this.muteVideo(video);
        }
      });
    }

    onVideoClick(event) {
      this.toggleSound(event.currentTarget);
    }

    onSoundButtonClick(event) {
      event.preventDefault();
      const item = event.currentTarget.closest('.ugc-videos__item');
      const video = item && item.querySelector('video');

      if (video) {
        this.toggleSound(video);
      }
    }

    toggleSound(video) {
      const shouldActivate = video.muted || video.paused || this.activeVideo !== video;

      this.videos.forEach((currentVideo) => {
        if (currentVideo !== video) {
          this.muteVideo(currentVideo);
        }
      });

      if (shouldActivate) {
        video.muted = false;
        video.play().catch(() => {});
        this.activeVideo = video;
      } else {
        this.muteVideo(video);
      }

      this.syncButtons();
    }

    muteVideo(video) {
      video.muted = true;
      video.play().catch(() => {});

      if (this.activeVideo === video) {
        this.activeVideo = null;
      }
    }

    syncButton(video) {
      const item = video.closest('.ugc-videos__item');
      const button = item && item.querySelector('.ugc-videos__sound-button');

      if (!button) {
        return;
      }

      const isActive = !video.muted && !video.paused;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.setAttribute('aria-label', isActive ? 'Silenciar audio' : 'Activar audio');
    }

    syncButtons() {
      this.videos.forEach((video) => this.syncButton(video));
    }
  }

  if (!customElements.get('ugc-videos')) {
    customElements.define('ugc-videos', UgcVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
